import { render } from "./EnvironmentWater.vue?vue&type=template&id=6f9c25dc&ts=true"
import script from "./EnvironmentWater.vue?vue&type=script&lang=ts"
export * from "./EnvironmentWater.vue?vue&type=script&lang=ts"

import "./EnvironmentWater.vue?vue&type=style&index=0&id=6f9c25dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__